import { scopes } from "./scripts-scopes-screen.js";
import { regular } from "./scripts-regular-screen.js";
import { actions } from "./scripts-actions-screen.js";

export default {
	scopes,
	regular,
	actions
}